const useTokenWithPat = () => {
  const getToken = () =>
    'pat_H7kcjSAhDWRlVNQ2xfGdAa1iLUeAIYVuyZuKziJxJjg2fjrITLXEW9VfBGo7tSUS';
  return {
    getToken,
  };
};

export { useTokenWithPat };
